// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousThursday as fn } from "../previousThursday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousThursday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default previousThursday;
